<template>
  <div>
    <base-info ref="baseInfo" v-model="form" @telegraphicTransferNumBlur="handleTelegraphicTransferNumBlur" />
    <contractFile v-if="form.attachmentList" :form="form" />
    <rate-info ref="rateInfo" v-model="form" />
    <FormInput ref="formInput" :base-info="form" />
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit">
          确认
        </el-button>
        <!-- <el-button type="primary" @click="$router.push({name: 'FinanceRemittanceList'})">取消</el-button> -->
        <el-button type="default" @click="dialogVisible = true">
          驳回
        </el-button>
      </div>
    </div>
    <el-dialog
      title="驳回原因"
      :visible.sync="dialogVisible"
      width="360px"
      @close="revokeDialogClose"
    >
      <el-input
        v-model="deleteReason"
        type="textarea"
        placeholder="请输入驳回原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="mini" :loading="revockLoading" @click="handleDeleteDebit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import baseInfo from './BaseInfo';
import rateInfo from './RateInfo';
import FormInput from './FormInput';
import contractFile from './contractFile';
import { turnDownTelegraphicTransfer } from '@/API/index.js';
import { telegraphicTransferInternation, verifyreceiptnumber, confirmCollection } from '@/API/international';
// confirmCollection
export default {
  data () {
    return {
      form: {
      },
      isform: '',
      loading: false,
      deleteReason: '',
      revockLoading: false,
      dialogVisible: false,
      crossCurrencyFlag: 0,
      receiptCurrency: '' // 收款单币种
    };
  },
  components: {
    baseInfo,
    rateInfo,
    contractFile,
    FormInput
  },
  methods: {
    // 处理收款单号失去焦点事件
    handleTelegraphicTransferNumBlur (currency) {
      this.receiptCurrency = currency;
    },
    async submit (val) {
      const { form, lcFiles } = await this.$refs.formInput.validate();
      const telegraphicTransferNum = await this.$refs.formInput.baseInfo.telegraphicTransferNum;
      if (form) {
        this.loading = true;
        let params = {
          id: this.$route.params.id,
          ...form,
          lcFiles: lcFiles,
          telegraphicTransferNum: telegraphicTransferNum,
          orderUnit: this.form.orderUnit,
          crossCurrencyFlag: this.crossCurrencyFlag
        };

        // 财务补录才触发校验
        if (!this.isform && this.receiptCurrency !== this.form.currency) {
          this.$message.warning('收款单币种与交易币种不一致');
          this.loading = false;
          return false;
        }

        if (this.form.importCompany === 'Star-NetRuijie(HongKong)CompanyLimited.') {
          params.actualRemittanceAmount = 0;
          confirmCollection(params).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.$notify.success('操作成功');
              this.$router.replace({ name: 'FinanceRemittanceList' });
            }
          }).catch(() => {
            this.loading = false;
          });
        } else if (!this.isform) {
          let paramso = {
            receiptNumber: telegraphicTransferNum,
            type: 1
          };
          if (this.form.remittanceAmount < form.actualRemittanceAmount) {
            this.$message({
              message: '实际到款金额应小于等于付款金额，请重新输入',
              type: 'warning'
            });
            this.loading = false;
          }
          verifyreceiptnumber(paramso).then((res) => {
            const json = res.data;
            if (json.status === '200') {
              if (json.data.isReceipt === true) {
                this.$message.success('该收款单号已生成收款单');
                this.loading = false;
                return false;
              }
              if (json.data.bussinessEntity !== '福建锐捷' && json.data.account !== this.form.importAccount) {
                this.$message.warning('收款单汇入账号与所选汇入账号不一致');
                this.loading = false;
                return false;
              }
              this.receiptCurrency = json.data.currency;
              if (this.receiptCurrency !== this.form.currency) {
                this.$message.warning('收款单币种与交易币种不一致');
                this.loading = false;
                return false;
              }
              confirmCollection(params).then((res) => {
                let json = res.data;
                this.loading = false;
                if (json.status === '200') {
                  this.$notify.success('操作成功');
                  this.$router.replace({ name: 'FinanceRemittanceList' });
                }
              }).catch(() => {
                this.loading = false;
              });
            } else {
              this.loading = false;
            }
          }).catch((err) => {
            console.log(err);
          });
        } else if (this.isform) {
          confirmCollection(params).then((res) => {
            let json = res.data;
            this.loading = false;
            if (json.status === '200') {
              this.$notify.success('操作成功');
              this.$router.replace({ name: 'FinanceRemittanceList' });
            }
          }).catch(() => {
            this.loading = false;
          });
        }
      }
    },
    revokeDialogClose () {
      this.deleteReason = '';
      this.dialogVisible = false;
      this.revockLoading = false;
    },
    handleDeleteDebit () {
      this.revockLoading = true;
      if (this.deleteReason === '') {
        this.$message.error('请输入驳回原因');
        this.revockLoading = false;
        return;
      }
      let parmas = {
        telegraphicTransferId: this.$route.params.id,
        rejectionContent: this.deleteReason
      };
      turnDownTelegraphicTransfer(parmas).then((res) => {
        let json = res.data;
        this.revockLoading = false;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '驳回成功 !'
          });
          this.revokeDialogClose();
          this.$router.push({
            name: 'FinanceRemittanceList'
          });
        }
      }).catch(() => {
        this.revockLoading = false;
      });
    },
    init () {
      telegraphicTransferInternation(this.$route.params.id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.crossCurrencyFlag = json.data.telegraphicTransferNum ? json.data.crossCurrencyFlag : 0; // 跨币种标识
          this.form.exchangeRateDate = json.data.exchangeRateDate ? json.data.exchangeRateDate.split(' ')[0] : ''; // 汇率日期
          if (json.data.telegraphicTransferNum) {
            this.isform = json.data.telegraphicTransferNum;
          }
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  },
  mounted () {
    this.init();
  }
};
</script>
<style lang="scss" scoped>
</style>
